import { render, staticRenderFns } from "./ProfitByKiosk.vue?vue&type=template&id=978a8fe8&"
import script from "./ProfitByKiosk.vue?vue&type=script&lang=js&"
export * from "./ProfitByKiosk.vue?vue&type=script&lang=js&"
import style0 from "./ProfitByKiosk.vue?vue&type=style&index=0&id=978a8fe8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports